export default __webpack_public_path__ + "static/media/wap_platform_introduction_pic2.21f529c3.png";